import { Dayjs } from "dayjs";

// Helpers
import { isAllowKeyboardEvents } from "src/helpers/common.helper";
import { mergeDateTime } from "src/helpers/date.helper";

export const filterOptions = (
    input: string,
    option: SelectOption | undefined
) => {
    const childenInput = option?.label ?? option?.children;
    return childenInput?.toLowerCase().includes(input.toLowerCase());
};

export const validateDateTimeRange = (
    dateFrom: Dayjs,
    timeFrom: string,
    dateTo: Dayjs,
    timeTo: string,
    timeSeperator: string = "."
) => {
    if (!dateFrom || !dateTo) {
        return true;
    }

    if (!timeFrom || !timeTo) {
        return dateFrom.clone().add(1, "day").isBefore(dateTo);
    }

    const from = mergeDateTime(dateFrom, timeFrom, timeSeperator).startOf(
        "minute"
    );
    const to = mergeDateTime(dateTo, timeTo, timeSeperator).startOf("minute");

    return from.clone().add(1, "day").startOf("day").isBefore(to);
};

export const handleNameKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
        !(
            isAllowKeyboardEvents(e) ||
            /[\u0E00-\u0E7Fa-zA-Z. -/(/)]/g.test(e.key)
        )
    ) {
        e.preventDefault();
    }
};

export const handleNumberOnlyKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>
) => {
    if (!(isAllowKeyboardEvents(e) || /[0-9]/g.test(e.key))) {
        e.preventDefault();
    }
};

export const handleEngCharAndNumberKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>
) => {
    if (!(isAllowKeyboardEvents(e) || /[a-zA-Z0-9]/g.test(e.key))) {
        e.preventDefault();
    }
};

export const transformCountryOptions = (
    countries: Country[]
): SelectOption[] => {
    const { list } = countries.reduce<{
        list: SelectOption[];
        obj: Record<string, boolean>;
    }>(
        (result, { countryCode }) => {
            const { list, obj } = result;

            if (obj[countryCode]) {
                return result;
            }

            return {
                obj: {
                    ...obj,
                    [countryCode]: true,
                },
                list: [
                    ...list,
                    {
                        label: countryCode,
                        value: countryCode,
                    },
                ],
            };
        },
        {
            list: [],
            obj: {},
        }
    );

    return list;
};

export const validateThaiCitizenId = (id: string): boolean => {
    if (!id || id.length < 13) {
        return false;
    }

    let sum: number = 0;
    for (var i = 0; i < id.length - 1; i++) {
        sum += parseInt(id[i]) * (13 - i);
    }

    const checkDigit = (11 - (sum % 11)) % 10;
    const isValid = checkDigit === parseInt(id[12]);
    return isValid;
};

export const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });
};
